import { render, staticRenderFns } from "./tabs-item.vue?vue&type=template&id=89b5020a&scoped=true&"
import script from "./tabs-item.vue?vue&type=script&lang=js&"
export * from "./tabs-item.vue?vue&type=script&lang=js&"
import style0 from "./tabs-item.vue?vue&type=style&index=0&id=89b5020a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b5020a",
  null
  
)

export default component.exports